<template>
  <header class="dflexr-jcsb mp_header">
    <div class="hdr-city-name hdr-col">
      <span class="hdr-lbl">City Name</span>
      <div class="hdr-cityname-txt">
        {{ mp_pkg.cityName}}
      </div>
    </div>

    <div class="hdr-populaton_cvt hdr-col">
      <span class="hdr-lbl">Population</span>
      <div class="hdr-populaton_cvt-txt">
        {{ mp_pkg.population }}
      </div>
    </div>

    <div class="hdr-num-markets hdr-col">
      <span class="hdr-lbl">Number of Markets</span>
      <div class="hdr-num-markets-txt">
        {{ numMarkets }}
      </div>
    </div>

  </header>

</template>

<style scoped lang="scss">
@import '../../assets/styles/colors.scss';

  .mp_header {
    border: 1px solid cyan;
    border-top-left-radius: 8px;
    padding: 3px 1rem;
    width: 100%;

    .hdr-col {
      flex: 1;
    }

    .hdr-lbl {
      font-weight: bold;
      color: $fg-base-lt30
    }

    .hdr-city-name {
      width: 100%;
    }

  }


</style>

<script setup>

import {computed, inject} from "vue";

const mp_pkg = inject('mp_pkg')

const numMarkets = computed(() => {
  let x = 0
  if(mp_pkg && typeof mp_pkg.population === 'string') {
    x = parseInt(mp_pkg.population)
  }
  let numMP = Math.floor(x / 2000)
  const x2 = x % 2000
  if(x2 >= 500)
    numMP += 1
  if(numMP === 0)
    numMP = 1
  return numMP
})

console.log('[MarketPlaceSelector] ', mp_pkg.list)


</script>
